<template>
    <v-dialog v-model="show" max-width="700" persistent no-click-animation>
        <v-card style="position: relative">
            <v-layout align-center class="primary px-2 py-1">
                <div class="title" style="color: #fff">Bot Selector</div>
                <v-spacer></v-spacer>
                <v-btn small icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-layout>
            <div class="dialog-body">
                <div style="padding: 10px">
                    <v-text-field
                        :label="this.$f.tc('search')"
                        outlined
                        hide-details
                        dense
                        v-model="searchKey"
                    ></v-text-field>
                </div>
                <div class="fci-list">
                    <v-layout v-for="bot in filterBotList" :key="bot.code" class="fci-list-item"
                        @click="selectBot(bot)">
                        <div class="mr-3">{{ bot.name }}</div>
                    </v-layout>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from '@/modules/fptai/mixins/DialogPromiseMixin'

export default {
    name: 'BotSelectorDialog',
    mixins: [DialogPromiseMixin],
    data () {
        return {
            botList: [],
            searchKey: ''
        }
    },
    computed: {
        filterBotList () {
            let search = this.searchKey.trim().toLowerCase()
            return this.botList.filter(bot => bot.name.toLowerCase().includes(search))
        }
    },
    methods: {
        open (botList) {
            this.botList = botList
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        selectBot (bot) {
            this.searchKey = ''
            this.promise.resolve(bot)
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
.fci-list {
    height: 700px;
    overflow: auto;

    .fci-list-item {
        padding: 10px;
    }
}
</style>
